module.exports = "/_next/static/images/ao-2359a082179b9fee8acd24178b026f0e.svg";